// modules
import { createAction } from 'redux-actions'

export const setUserSearch = createAction('SET_USER_SEARCH')

export const resetUserSearch = createAction('RESET_USER_SEARCH')
